/* ==========================================================================
   MEE BARSA — Shared header search behaviour

   Rules, straight from the client spec:
   1. The icon opens the field IN PLACE. It never navigates.
   2. An empty query is never submitted — so the blank /search landing page
      can no longer be reached by clicking the icon.
   3. Hover opens it (Anjali's ask); a click LOCKS it open, so it cannot
      evaporate while you are typing. Same principle as the click-to-open menu.
   4. Escape, or a click anywhere outside, closes an empty field.
   ========================================================================== */
(function () {
  'use strict';

  // the snippet can appear twice on a page (header + phone drawer), and the
  // asset tag comes with it — bind the delegated listeners once only.
  if (window.__mbSearchBound) return;
  window.__mbSearchBound = true;

  var OPEN = 'is-open';

  function parts(wrap) {
    return {
      form: wrap.querySelector('.mb-search-form'),
      input: wrap.querySelector('.mb-search-input'),
      toggle: wrap.querySelector('.mb-search-toggle')
    };
  }

  function open(wrap, focus) {
    var p = parts(wrap);
    wrap.classList.add(OPEN);
    if (p.toggle) p.toggle.setAttribute('aria-expanded', 'true');
    if (focus && p.input) {
      // wait for the width transition to start so iOS keeps the caret visible
      window.requestAnimationFrame(function () { p.input.focus(); });
    }
  }

  function close(wrap) {
    var p = parts(wrap);
    wrap.classList.remove(OPEN);
    if (p.toggle) p.toggle.setAttribute('aria-expanded', 'false');
    if (p.input && document.activeElement === p.input) p.input.blur();
  }

  function closeAllEmpty(except) {
    var all = document.querySelectorAll('[data-mb-search].' + OPEN);
    for (var i = 0; i < all.length; i++) {
      var w = all[i];
      if (w === except) continue;
      var v = parts(w).input;
      if (!v || !v.value.trim()) close(w);
    }
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest ? e.target.closest('.mb-search-toggle') : null;

    if (toggle) {
      var wrap = toggle.closest('[data-mb-search]');
      if (!wrap) return;
      var p = parts(wrap);
      var value = p.input ? p.input.value.trim() : '';

      if (wrap.classList.contains(OPEN) && value) {
        p.form.submit();          // second press with a real query = search
        return;
      }
      if (wrap.classList.contains(OPEN) && document.activeElement === p.input) {
        close(wrap);              // press again on an empty open field = tidy away
        return;
      }
      open(wrap, true);
      closeAllEmpty(wrap);
      return;
    }

    // clicking anywhere else tidies away any empty open field
    var inside = e.target.closest ? e.target.closest('[data-mb-search]') : null;
    closeAllEmpty(inside);
  });

  // never submit an empty query — that is what produced the bare search page
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('mb-search-form')) return;
    var input = form.querySelector('.mb-search-input') || form.querySelector('input[name="q"]');
    if (input && !input.value.trim()) {
      e.preventDefault();
      var wrap = form.closest('[data-mb-search]');
      if (wrap) open(wrap, true);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      var input = e.target.closest ? e.target.closest('.mb-search-input') : null;
      if (!input) return;
      var enterWrap = input.closest('[data-mb-search]');
      var enterParts = enterWrap ? parts(enterWrap) : null;
      if (!enterParts || !enterParts.form || !input.value.trim()) return;
      e.preventDefault();
      if (enterParts.form.requestSubmit) enterParts.form.requestSubmit();
      else enterParts.form.submit();
      return;
    }
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var wrap = e.target.closest ? e.target.closest('[data-mb-search]') : null;
    if (wrap) { close(wrap); return; }
    closeAllEmpty(null);
  });

  // focusing the field by keyboard should also mark it open
  document.addEventListener('focusin', function (e) {
    var input = e.target.closest ? e.target.closest('.mb-search-input') : null;
    if (!input) return;
    var wrap = input.closest('[data-mb-search]');
    if (wrap) open(wrap, false);
  });
})();
